<template>
  <div>
    
    <v-layout row wrap>
      <v-flex xs12 px-3>
        <v-timeline small bottom :dense="$vuetify.breakpoint.smAndDown">
          <v-timeline-item
            v-for="(item, i) in items"
            :key="i"
            :color="randomBlue()"
            :icon="item.icon"
            fill-dot
            small
            :class="`${i%2 == 0? 'text-xs-right':''}`"
          >
            <img v-if="item.type == 'image'" class="elevation-6" :src="item.url" width="100%">
            <blockquote v-if="item.type == 'twitter'" style="width:100;" class="twitter-tweet elevation-6"><a  class="elevation-6" :href="item.url"></a></blockquote> 
            <div v-if="item.type == 'facebook'" @load="facebookRefresh(item.rid)" class="fb-post elevation-6 mb-3" :data-href="item.url" data-width="500" data-show-text="true"></div>
            <div style="width:100%" id="vidTopContainer">
              <iframe v-if="item.type == 'youtube'" @load="iframeResize()"  class="elevation-6" :src="item.url" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
            <a v-if="item.type == 'link'" target="_blank" class="customlink" :href="item.url">
            <v-card v-if="item.type == 'link'" class="elevation-6 mb-2" @click="goToURL(item.url)">
              <img :src="item.image" width="100%">
              <v-card-text class="text-xs-left">
                <div style="font-size:10px;font-weight:700;text-decoration: none !important;" v-if="item.url">{{item.url.substring(0, 30)}}..</div>
                <div style="font-size:14px;font-weight:700;text-decoration: none !important;">{{item.title}}</div>
                <div style="text-decoration: none !important;">{{item.description}}</div>
                <v-chip label small class="ma-0 mt-1 white--text" v-if="item.source" color="primary">{{item.source}}</v-chip>
              </v-card-text>
            </v-card></a>
            <v-card class="elevation-6">
              <v-card-text class="text-xs-left">
                {{item.comment}}
              </v-card-text>
              <v-card-actions v-if="superAdmin">
                <v-textarea
                  label="Comment"
                  solo
                  hide-details
                  v-model="item.comment"
                ></v-textarea>
                <v-btn color="success" @click="updatePost(item, item.token)">add comment</v-btn>
              </v-card-actions>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-flex>
    </v-layout>
   <!-- <div v-if="errorStr">
      Sorry, but the following error
      occurred: {{errorStr}}

    </div>
    
    <div v-if="gettingLocation">
      <i>Getting your location...</i>
    </div>
    
    <div v-if="location">
      Your location data is {{ location.coords.latitude }}, {{ location.coords.longitude}}
    </div> -->
  </div>
</template>

<script>
import { firebase, db, auth, perf, store, storageRef } from '@/fb'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, between, email, numeric, alpha } from 'vuelidate/lib/validators'
import { isEmail } from '@/validators'
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';
import axios from 'axios';
import urlMetadata from 'url-metadata';
import FileType from 'file-type';
import {makeTokenizer} from '@tokenizer/http';

const api = `https://us-central1-green-way-b58d5.cloudfunctions.net/main`
const headers = {'Accept': 'application/json'};
// import countries from '@/countries'
let prefix, cc


export default {
  mixins: [validationMixin],
   components: {
  },
  props:{
    superAdmin:{},
    userData:{},
    userName:{},
  },
  data () {
    return {
      loading: false,
      last:null,
      location:null,
      gettingLocation: false,
      errorStr:null,
      uploadProgress:null,
      imgUploadProduct:null,
      file:null,
      imgURLExt:null,
      vidWidth:null,
      vidHeight:null,
      items: [
        
      ],
    }
  },
  methods: {
    goToURL(url){
      window.location.href = url
    },
    randomBlue(){
      return "rgb(0, 0, " + (Math.floor(Math.random() * 255)) + ")";
    },  
    clipboardSuccessHandler ({ value, event }){
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    iframeResize(){
      let a = document.querySelectorAll("iframe")
      if(a) {
        for (let i = 0; i < a.length; i++) {
          const frame = a[i];
          let w = frame.parentNode.offsetWidth
          frame.setAttribute('width', w)
          let h = w * 315/530
          frame.setAttribute('height', h)
        }
      }
    },
    facebookRefresh(id){
      FB.XFBML.parse(document.getElementById(id))
    },
    understand(string){
      const decipher = salt => {
          const textToChars = text => text.split('').map(c => c.charCodeAt(0));
          const applySaltToChar = code => textToChars(salt).reduce((a,b) => a ^ b, code);
          return encoded => encoded.match(/.{1,2}/g)
              .map(hex => parseInt(hex, 16))
              .map(applySaltToChar)
              .map(charCode => String.fromCharCode(charCode))
              .join('');
      }
      const myDecipher = decipher('gw')
      return myDecipher(string)
    },
    goTo(path) {
      this.$router.push(path)
    },
    getLocationAuto(){
      if(!("geolocation" in navigator)) {
        this.errorStr = 'Geolocation is not available.';
        return;
      }

      this.gettingLocation = true;
      // get position
      navigator.geolocation.getCurrentPosition(pos => {
        this.gettingLocation = false;
        this.location = pos;
      }, err => {
        this.gettingLocation = false;
        this.errorStr = err.message;
      })
    },
    loadFile(file, type, ext){
      var file = file
      var metadata = {
        contentType: type
      };
      var uploadTask = storageRef.child('images/dr_maen_k_house_maenupdates' + randomString(8, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log(progress)
					this.uploadProgress = progress
                }, (error) =>{
        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
          this.newPost({
            type:'image',
            url:downloadURL
          })
					this.imgUploadProduct = false
					this.uploadProgress = 100
        });
      });
    },
    onFilePicked (image) {
      this.imgUploadProduct = true
      const files = [image]
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          this.imgURLExt = `.${this.file.name.split('.').pop()}`
          this.loadFile(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } else {
        this.name = null
      }
    },
    lsnToPaste(){
      var dropZone = document.getElementById('drop_zone');
      dropZone.addEventListener('dragover', this.handleDragOver, false);
      dropZone.addEventListener('drop', this.handleFileSelect, false);
      window.addEventListener("paste", async (thePasteEvent) => {
          // Use thePasteEvent object here ...
          let items = thePasteEvent.clipboardData.items
          for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.type.includes("image")) {
              console.log(item.getAsFile())
              this.onFilePicked (item.getAsFile())
            } 
            if(item.type.includes("text/plain")) {
              item.getAsString(async x=>{
                console.log(x)
                if(x.startsWith('https://twitter.com/')) {
                  this.newPost({
                    type:'twitter',
                    url:x
                  })
                } else if(x.startsWith('https://www.facebook.com/')) {
                  this.newPost({
                    type:'facebook',
                    url:x
                  })
                } else if(x.startsWith('https://www.youtube.com/')) {
                  this.newPost({
                    type:'youtube',
                    url:x.replace('https://www.youtube.com/watch?v=', 'https://www.youtube.com/embed/')
                  })
                } else if(x.startsWith('http')) {
                  let m = await axios.get(`${api}/getMetaData?url=${x}`).then(x=>x.data)
                  if(m.success && m.metadata){
                    this.newPost({
                      type:'link',
                      url:m.metadata.url,
                      title:m.metadata.title,
                      description:m.metadata.description,
                      image:m.metadata.image ? m.metadata.image : m.metadata["og:image"],
                      source:m.metadata.source
                    })
                  }
                }
              })
            }
            console.log(item)
          }

      }, false);
    },
    genToken() {
      this.loading = true
      let vtoken = `DR_MAEN_${randomString(8, 'aA#')}`
      this.loading = false
      return vtoken
    },
    async LoadLight(){
      this.loading = true
      let a = await store.collection(`posts`).orderBy("date", 'desc').limit(5).get().then(x=>x.docs.map((y, i)=>{
        if(i==x.docs.length-1) this.last = y
        return y.data()
      }))
      this.items = a.map(x=>{return {...x,rid:this.genToken()}})
      for (let i = 0; i < a.length; i++) {
        const it = a[i];
        this.facebookRefresh(it.rid)
      }
      twttr.widgets.load();
      this.iframeResize()
      this.loading = false
    },
    async nextLight(){
      this.loading = true
      let a = await store.collection(`posts`).orderBy("date", 'desc').limit(5).startAfter(this.last).get().then(x=>x.docs.map((y, i)=>{
        if(x.docs.length > 0 && i==x.docs.length-1) this.last = y
        y.rid=this.genToken()
        return y.data()
      }))
      this.items = [...this.items, ...a]
      for (let i = 0; i < a.length; i++) {
        const it = a[i];
        this.facebookRefresh(it.rid)
      }
      twttr.widgets.load();
      this.iframeResize()
      this.loading = false
    },
    scroll () {
      window.onscroll = () => {
        if (((window.innerHeight + window.scrollY) >= document.body.offsetHeight - (document.body.offsetHeight*70/100) 
          && this.loading == false
          )) {
          this.nextLight()
        }
      };
    },
    handleFileSelect(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      var files = evt.dataTransfer.files; // FileList object.
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        this.onFilePicked (file)
      }
    },
    handleDragOver(evt) {
      evt.stopPropagation();
      evt.preventDefault();
      evt.dataTransfer.dropEffect = 'copy'; // Explicitly show this is a copy.
    },
    async newPost(post){
      post.date = new Date().getTime()
      post.token = this.genToken()
      await store.collection('posts').doc(`${post.token}`).set(post)
      this.items = []
      this.LoadLight()
    },
    async updatePost(post, token){
      await store.collection('posts').doc(`${token}`).set(post)
      this.items = []
      this.LoadLight()
    }
  },
  computed:{
    

  },
  validations: {
    
  },
  watch: {
    loading(){
      if(!this.loading) {
        this.iframeResize()
        FB.XFBML.parse()
      }
    }
  },
  async created() {
    this.LoadLight()
  },
  mounted() {
    this.iframeResize()
    this.lsnToPaste()
    this.scroll()
    
  },
  destroyed(){
  }
}
</script>
<style>
.twitter-tweet-rendered {
  -webkit-box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12) !important;
  box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12) !important;
  border-radius: 4px;
}
a {
  text-decoration: none !important; 
}
</style>
